import { createApi } from '@reduxjs/toolkit/query/react';
import baseQuery from '../../Shared/API/config';

export const SubjectsApi = createApi({
  reducerPath: 'SubjectsApi',
  baseQuery,
  tagTypes: ['Subject'],
  endpoints: builder => ({
    getSubjects: builder.query<any, void>({
      query: () => `/academics/subjects`,
      providesTags: ['Subject'],
    }),
    createSubject: builder.mutation<any, any>({
      query: newSubject => ({
        url: '/academics/subjects',
        method: 'POST',
        body: newSubject,
      }),
      invalidatesTags: ['Subject'],
    }),
    updateSubject: builder.mutation<any, any>({
      query: ({ id, updates }) => ({
        url: `/academics/subjects/${id}`,
        method: 'PATCH',
        body: updates,
      }),
      invalidatesTags: ['Subject'],
    }),
    deleteSubject: builder.mutation<void, { id: string }>({
      query: ({ id }) => ({
        url: `/academics/subjects/${id}`,
        method: 'DELETE',
      }),
      invalidatesTags: ['Subject'],
    }),
  }),
});

export const {
  useGetSubjectsQuery,
  useCreateSubjectMutation,
  useUpdateSubjectMutation,
  useDeleteSubjectMutation,
} = SubjectsApi;
